'use client';

import { AnimatePresence, motion } from 'framer-motion';
import { Check } from 'lucide-react';

// Confirmación de acceso al centro de la pantalla: backdrop + tarjeta con un
// check que "rebota" al entrar. Se muestra mientras Login.tsx espera antes
// de transicionar al shell autenticado.
export default function LoginSuccessOverlay({ nombre }: { nombre: string | null }) {
  return (
    <AnimatePresence>
      {nombre && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25, ease: 'easeOut' }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[#052e16]/55 p-4 backdrop-blur-sm"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.85, y: 12 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.92 }}
            transition={{ duration: 0.35, ease: 'easeOut' }}
            className="flex flex-col items-center gap-4 rounded-3xl border border-white/60 bg-white/95 px-10 py-9 text-center shadow-2xl"
          >
            <motion.span
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.45, delay: 0.1, ease: [0.34, 1.56, 0.64, 1] }}
              className="flex size-16 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/30"
            >
              <Check className="size-8" strokeWidth={3} />
            </motion.span>
            <div>
              <p className="text-xl font-bold tracking-tight text-slate-900">
                Acceso concedido
              </p>
              <p className="mt-1 text-sm text-slate-500">Bienvenido, {nombre}.</p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
